import axios from 'axios'

let baseUrl = 'https://prod.turasistan.com/api/'
if (window.location.origin.toLowerCase().indexOf('localhost') > -1) {
	// baseUrl = 'http://localhost:1217/api/'
	// baseUrl = 'https://prodtest.turasistan.com/api/'
	// baseUrl = 'http://prod.turasistan.com/api/'
}

const Api = axios.create({
	baseURL: baseUrl,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
})


export default Api



// WEBPACK FOOTER //
// ./src/config/api.js